import {
 
  EMPLOYEES_BASE_URL,
  STOCKITEMS_BASE_URL,
  API_URL,
  API_KEY,
  REQUEST_TOKEN_URL,
  LOGIN_URL,
  SESSION_ID_URL,
  API_TOKEN,
  Files_BASE_URL,
  WAREHOUSES_BASE_URL,
  USERS_BASE_URL,
  STOCKTRANSACTIONS_BASE_URL,
  IOD_BASE_URL,
  MESSAGES_BASE_URL,
  PAYROLLTRANSACTIONS_BASE_URL,
  PAYTYPES_URL,
  PAYRATES_URL,
  ADDITIONS_URL,
  CURRENTPAYSLIPS_URL,
  TIMEATTENDANCE_URL
  
} from './config';

import useAuth from './hooks/useAuth';


const defaultConfig = {
  
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer '+API_TOKEN
  }
};



const apiSettings = {
  fetchEmployees: async (searchTerm, page, includeInactive,endDate,accessToken) => {
   console.log(searchTerm)
    const endpoint = searchTerm
      ? `${EMPLOYEES_BASE_URL}?searchValue=${searchTerm}&includeInactive=${includeInactive}`
      : `${EMPLOYEES_BASE_URL}?includeInactive=${includeInactive}`;
      console.log(endpoint)
      console.log("net voor fetch response")
    
    return await (await fetch(endpoint,
      {method:"GET",
       
      headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
  
  fetchEmployee: async (employeeid, accessToken )=> {
    const endpoint = `${EMPLOYEES_BASE_URL}/${employeeid}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"GET",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },

  deleteEmployee: async (employeeid,accessToken) => {
    const endpoint = `${EMPLOYEES_BASE_URL}/${employeeid}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"DELETE",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
  fetchStockitems: async (searchTerm, page, includeInactive,endDate,accessToken) => {
    console.log(searchTerm)
     const endpoint = searchTerm
       ? `${STOCKITEMS_BASE_URL}?page=${page}&searchValue=${searchTerm}&includeInactive=${includeInactive}`
       : `${STOCKITEMS_BASE_URL}?page=${page}&includeInactive=${includeInactive}`;
       console.log(endpoint)
       console.log("net voor fetch response")
     
     return await (await fetch(endpoint,
       {method:"GET",
        
       headers: {
       'Content-Type': 'application/json',
       'Authorization': 'Bearer '+accessToken
     } })).json();
   },
   fetchStockitem: async (id, accessToken )=> {
    const endpoint = `${STOCKITEMS_BASE_URL}/${id}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"GET",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
  deleteStockitem: async (id,accessToken) => {
    const endpoint = `${STOCKITEMS_BASE_URL}/${id}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"DELETE",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
  fetchWarehouses: async (searchTerm, page, includeInactive,endDate,accessToken) => {
    console.log(searchTerm)
     const endpoint = searchTerm
       ? `${WAREHOUSES_BASE_URL}?searchValue=${searchTerm}&includeInactive=${includeInactive}`
       : `${WAREHOUSES_BASE_URL}?includeInactive=${includeInactive}`;
       console.log(endpoint)
       console.log("net voor fetch response")
     
     return await (await fetch(endpoint,
       {method:"GET",
        
       headers: {
       'Content-Type': 'application/json',
       'Authorization': 'Bearer '+accessToken
     } })).json();
   },
   fetchWarehouse: async (id, accessToken )=> {
    const endpoint = `${WAREHOUSES_BASE_URL}/${id}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"GET",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
  deleteWarehouse: async (id,accessToken) => {
    const endpoint = `${WAREHOUSES_BASE_URL}/${id}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"DELETE",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },

  fetchDocuments: async (searchTerm, page, startDate,endDate,accessToken) => {
    console.log(searchTerm)
     const endpoint = searchTerm
       ? `${Files_BASE_URL}?searchValue=${searchTerm}`
       : `${Files_BASE_URL}`;
       console.log(endpoint)
       console.log("net voor fetch response")
     
     return await (await fetch(endpoint,
       {method:"GET",
        
       headers: {
       'Content-Type': 'application/json',
       'Authorization': 'Bearer '+accessToken
     } })).json();
   },
   fetchFile: async (id,accessToken) => {
    const endpoint = `${Files_BASE_URL}/${id}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"GET",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
   deleteFile: async (id,accessToken) => {
    const endpoint = `${Files_BASE_URL}/${id}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"DELETE",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
  fetchUsers: async (searchTerm, page, includeInactive,endDate,accessToken) => {
    console.log(searchTerm)
     const endpoint = searchTerm
       ? `${USERS_BASE_URL}?searchValue=${searchTerm}&includeInactive=${includeInactive}`
       : `${USERS_BASE_URL}?includeInactive=${includeInactive}`;
       console.log(endpoint)
       console.log("net voor fetch response")
     
     return await (await fetch(endpoint,
       {method:"GET",
        
       headers: {
       'Content-Type': 'application/json',
       'Authorization': 'Bearer '+accessToken
     } })).json();
   },
   fetchUser: async (id, accessToken )=> {
    const endpoint = `${USERS_BASE_URL}/${id}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"GET",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
  deleteUser: async (id,accessToken) => {
    const endpoint = `${USERS_BASE_URL}/${id}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"DELETE",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
   fetchTransactions: async (searchTerm, page, includeInactive,endDate,accessToken) => {
    console.log(searchTerm)
     const endpoint = searchTerm
       ? `${STOCKTRANSACTIONS_BASE_URL}?searchValue=${searchTerm}&includeInactive=${includeInactive}`
       : `${STOCKTRANSACTIONS_BASE_URL}?includeInactive=${includeInactive}`;
       console.log(endpoint)
       console.log("net voor fetch response")
     
     return await (await fetch(endpoint,
       {method:"GET",
        
       headers: {
       'Content-Type': 'application/json',
       'Authorization': 'Bearer '+accessToken
     } })).json();
   },
   deleteTransaction: async (id,accessToken) => {
    const endpoint = `${STOCKTRANSACTIONS_BASE_URL}/${id}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"DELETE",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
  fetchInjuries: async (searchTerm, page, includeInactive,endDate,accessToken) => {
    console.log(searchTerm)
     const endpoint = searchTerm
       ? `${IOD_BASE_URL}?page=${page}&searchValue=${searchTerm}&includeInactive=${includeInactive}`
       : `${IOD_BASE_URL}?page=${page}&includeInactive=${includeInactive}`;
       console.log(endpoint)
       console.log("net voor fetch response")
     
     return await (await fetch(endpoint,
       {method:"GET",
        
       headers: {
       'Content-Type': 'application/json',
       'Authorization': 'Bearer '+accessToken
     } })).json();
   },
   fetchIODitem: async (id, accessToken )=> {
    const endpoint = `${IOD_BASE_URL}/${id}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"GET",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
  deleteIODitem: async (id,accessToken) => {
    const endpoint = `${IOD_BASE_URL}/${id}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"DELETE",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
  fetchMessages: async (searchTerm, page, includeInactive,endDate,accessToken) => {
    console.log(searchTerm)
     const endpoint = searchTerm
       ? `${MESSAGES_BASE_URL}?searchValue=${searchTerm}&includeInactive=${includeInactive}`
       : `${MESSAGES_BASE_URL}?includeInactive=${includeInactive}`;
       console.log(endpoint)
       console.log("net voor fetch response")
     
     return await (await fetch(endpoint,
       {method:"GET",
        
       headers: {
       'Content-Type': 'application/json',
       'Authorization': 'Bearer '+accessToken
     } })).json();
   },
   fetchPayrollTransactions: async (searchTerm, page, includeInactive,endDate,accessToken) => {
    console.log(searchTerm)
     const endpoint = searchTerm
       ? `${PAYROLLTRANSACTIONS_BASE_URL}?searchValue=${searchTerm}&includeInactive=${includeInactive}`
       : `${PAYROLLTRANSACTIONS_BASE_URL}?includeInactive=${includeInactive}`;
       console.log(endpoint)
       console.log("net voor fetch response")
     
     return await (await fetch(endpoint,
       {method:"GET",
        
       headers: {
       'Content-Type': 'application/json',
       'Authorization': 'Bearer '+accessToken
     } })).json();
   },
   fetchPayTypes: async (searchTerm, page, includeInactive,endDate,accessToken) => {
    console.log(searchTerm)
     const endpoint = searchTerm
       ? `${PAYTYPES_URL}?page=${page}&searchValue=${searchTerm}&includeInactive=${includeInactive}`
       : `${PAYTYPES_URL}?page=${page}&includeInactive=${includeInactive}`;
       console.log(endpoint)
       console.log("net voor fetch response")
     
     return await (await fetch(endpoint,
       {method:"GET",
        
       headers: {
       'Content-Type': 'application/json',
       'Authorization': 'Bearer '+accessToken
     } })).json();
   },
   fetchPayrates: async (searchTerm, page, includeInactive,endDate,accessToken) => {
    console.log(searchTerm)
     const endpoint = searchTerm
       ? `${PAYRATES_URL}?page=${page}&searchValue=${searchTerm}&includeInactive=${includeInactive}`
       : `${PAYRATES_URL}?page=${page}&includeInactive=${includeInactive}`;
       console.log(endpoint)
       console.log("net voor fetch response")
     
     return await (await fetch(endpoint,
       {method:"GET",
        
       headers: {
       'Content-Type': 'application/json',
       'Authorization': 'Bearer '+accessToken
     } })).json();
   },
   fetchAdditions: async (searchTerm, page, includeInactive,endDate,accessToken) => {
    console.log(searchTerm)
     const endpoint = searchTerm
       ? `${ADDITIONS_URL}?page=${page}&searchValue=${searchTerm}&includeInactive=${includeInactive}`
       : `${ADDITIONS_URL}?page=${page}&includeInactive=${includeInactive}`;
       console.log(endpoint)
       console.log("net voor fetch response")
     
     return await (await fetch(endpoint,
       {method:"GET",
        
       headers: {
       'Content-Type': 'application/json',
       'Authorization': 'Bearer '+accessToken
     } })).json();
   },
   fetchCurrentPayrunlists: async (searchTerm, page, includeInactive,endDate,accessToken) => {
    console.log(searchTerm)
     const endpoint = searchTerm
       ? `${CURRENTPAYSLIPS_URL}?page=${page}&searchValue=${searchTerm}&includeInactive=${includeInactive}`
       : `${CURRENTPAYSLIPS_URL}?page=${page}&includeInactive=${includeInactive}`;
       console.log(endpoint)
       console.log("net voor fetch response")
     
     return await (await fetch(endpoint,
       {method:"GET",
        
       headers: {
       'Content-Type': 'application/json',
       'Authorization': 'Bearer '+accessToken
     } })).json();
   },
   fetchCurrentPayslip: async (id, accessToken )=> {
    const endpoint = `${CURRENTPAYSLIPS_URL}/${id}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"GET",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
   deleteCurrentPayslip: async (id,accessToken) => {
    const endpoint = `${CURRENTPAYSLIPS_URL}/${id}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"DELETE",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
  deleteAllPayslips: async (accessToken) => {
    const endpoint = `${CURRENTPAYSLIPS_URL}/delete/deleteAll`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"DELETE",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
  fetchTimeAttendanceList: async (searchTerm, page, includeInactive,accessToken,startDate,endDate) => {
    console.log(searchTerm)
    const sDate = startDate?startDate:""
    const eDate = endDate?endDate:""

    console.log(sDate + "" + eDate)
     const endpoint = searchTerm
       ? `${TIMEATTENDANCE_URL}?page=${page}&searchValue=${searchTerm}&includeInactive=${includeInactive}&startDate=${startDate}&endDate=${endDate}`
       : `${TIMEATTENDANCE_URL}?page=${page}&includeInactive=${includeInactive}&startDate=${sDate}&endDate=${eDate}`;
       console.log(endpoint)
       console.log("net voor fetch response")
     
     return await (await fetch(endpoint,
       {method:"GET",
        
       headers: {
       'Content-Type': 'application/json',
       'Authorization': 'Bearer '+accessToken
     } })).json();
   },
   fetchTimeAttendance: async (id, accessToken )=> {
    const endpoint = `${TIMEATTENDANCE_URL}/${id}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"GET",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
   deleteTimeAttendance: async (id,accessToken) => {
    const endpoint = `${TIMEATTENDANCE_URL}/${id}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"DELETE",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
  deleteTimeAttendanceDate: async (date,accessToken) => {
    const endpoint = `${TIMEATTENDANCE_URL}/deleteDate/${date}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint,{method:"DELETE",headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    } })).json();
  },
  // Bonus material below for login
  getRequestToken: async () => {
    const reqToken = await (await fetch(REQUEST_TOKEN_URL)).json();
    return reqToken.request_token;
  },
  authenticate: async (requestToken, username, password) => {
    const bodyData = {
      username,
      password,
      request_token: requestToken
    };
    // First authenticate the requestToken
    const data = await (
      await fetch(LOGIN_URL, {
        ...defaultConfig,
        body: JSON.stringify(bodyData)
      })
    ).json();
    // Then get the sessionId with the requestToken
    if (data.success) {
      const sessionId = await (
        await fetch(SESSION_ID_URL, {
          ...defaultConfig,
          body: JSON.stringify({ request_token: requestToken })
        })
      ).json();
      return sessionId;
    }
  }
  
};

export default apiSettings;
